/* eslint-disable */
import React, { useEffect, useState } from "react";

import HeSearch from "../../components/HeSearch";
import HeModal from "../../components/HeModal";
import HeEPSDownloadReport from "../../components/HeEPS/DownloadReport";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";

import "./app.scss";
let downloadFormRef;

function App(props) {
    const [benchmarkGeo, set_benchmarkGeo] = useState({
        id: "0",
        label: "United States",
    });

    const [state, set_state] = useState({
        isDownloadModalOpen: false,
        selectedGeo: null,
    });

    // force a render after the element have loaded once
    const [loaded, set_loaded] = useState(false);
    useEffect(() => {
        set_loaded(true);
    }, []);
    if (!loaded) return null;

    //fetch the wordpress data
    const apps = document.getElementsByClassName("he-app-root");
    const wpData = apps.length === 0 ? {} : apps[props.blockIndex].dataset;

    let reportTemplate = wpData.report || 'trends';
    
    return (
        <div className="app-eps-configurable-report sans">
            <div className="innerContainer">
                <div style={{ paddingRight: 20 }} className="app-icon">
                    <img src="/wp-content/uploads/HE-Tool-EPS-220x220.png" />
                </div>
                <div>
                    <h3 className="headerContainer">
                        {wpData.hdr || "Download a Socioeconomic Report"}
                    </h3>
                    <div className="description">
                        {wpData.desc ||
                            "A custom report from our Economic Profile System showing long-term trends in population, employment, personal income, income by industry, wages, and unemployment."}
                    </div>
                    <div className="searchContainer">
                        <HeSearch
                            geoTypes={wpData.geos || "he-state"}
                            onSelect={(val) =>
                                set_state({
                                    isDownloadModalOpen: true,
                                    selectedGeo: val,
                                })
                            }
                            placeholder={wpData.placeholder || "Which state?"}
                        />
                    </div>
                    
                </div>
                <div className="toolsLink">
                        <a href="/tools">See more socieoeconomic reports</a>
                    </div>
            </div>
            <HeModal
                headerText={"Download Report"}
                headerFontAwesomeIcon={
                    <FontAwesomeIcon
                        icon={faFileDownload}
                        style={{ color: "#367ebd" }}
                    />
                }
                isOpen={state.isDownloadModalOpen}
                onCloseRequest={() =>
                    set_state({
                        isDownloadModalOpen: false,
                        selectedGeo: null,
                    })
                }
                onDownloadRequest={() => {
                    downloadFormRef.submitViaCors();
                }}
                content={
                    !state.isDownloadModalOpen ? null : (
                        <HeEPSDownloadReport
                            TemplateName={reportTemplate}
                            requestSource="eps-configurable-report"
                            printFormatOptions={wpData.printformatoptions || "both"}
                            Group1_geoCodes={[state.selectedGeo.id]}
                            Group1_Aggregate={false}
                            Group1_Region={false}
                            Group1_Benchmark={false}
                            Group2_overrideName={state.selectedGeo.label}
                            Group3_overrideName={benchmarkGeo.label}
                            hideSubtitleField={true}
                            hideTitleField={true}
                            onRef={(ref) => (downloadFormRef = ref)}
                            benchmarkGeo={benchmarkGeo}
                            onBenchmarkGeoUpdate={set_benchmarkGeo}
                        />
                    )
                }
            />
        </div>
    );
}

export default App;
